import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import {
  ConsultarTarifasIndividualesParams,
  ConsultarTarifasIndividualesRequest
} from '../../models/cotizador-contratante/consultar-tarifas-individuales/request/consultar-tarifas-individuales-request.model';
import { ConsultarTarifasIndividualesResponse } from '../../models/cotizador-contratante/consultar-tarifas-individuales/response/consultar-tarifas-individuales-response.model';
import {
  ConsultarTarifasIndividualesValoresParams,
  ConsultarTarifasIndividualesValoresRequest
} from '../../models/cotizador-contratante/consultar-tarifas-individuales-valores/request/consultar-tarifas-individuales-valores-request.model';
import { ConsultarTarifasIndividualesValoresResponse } from '../../models/cotizador-contratante/consultar-tarifas-individuales-valores/response/consultar-tarifas-individuales-valores-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarTarifasIndividualesService {
  private readonly apiUrlLegacy = `${environment.HOST}${URL_MAP.API.CONSULTAR_TARIFAS_INDIVIDUALES}`;
  private readonly apiUrlValores = `${environment.HOST}${URL_MAP.API.CONSULTAR_TARIFAS_INDIVIDUALES_VALORES}`;

  constructor(private httpClient: HttpClient) { }

  consultarTarifasIndividualesLegacy(params: ConsultarTarifasIndividualesParams): Observable<ConsultarTarifasIndividualesResponse> {
    const request: ConsultarTarifasIndividualesRequest = {
      nombreClave: 'getTarifasCotizador',
      jsonParametros: JSON.stringify({
        pnu_pagina: params.pnu_pagina ?? '1',
        pnu_tamanoPagina: params.pnu_tamanoPagina ?? '1000',
        lineaNegocio: params.lineaNegocio,
        plan: params.plan ?? '',
        grupoPrograma: params.grupoPrograma ?? '',
        programa: params.programa,
        planTarifario: params.planTarifario ?? '',
        pvc_campoOrden: params.pvc_campoOrden ?? ''
      })
    };

    return this.httpClient.post<ConsultarTarifasIndividualesResponse>(this.apiUrlLegacy, request).pipe(
      catchError(error => {
        console.error('Error en consultarTarifasIndividualesLegacy:', error);
        return throwError(() => new Error(error?.message || 'Error al consultar tarifas individuales legacy'));
      })
    );
  }

  consultarTarifasIndividualesValores(
    params: ConsultarTarifasIndividualesValoresParams
  ): Observable<ConsultarTarifasIndividualesValoresResponse> {
    const request: ConsultarTarifasIndividualesValoresRequest = {
      nombreClave: 'getTarifasCotizadortrl',
      jsonParametros: JSON.stringify({
        prm_cuenta: params.prm_cuenta ?? '',
        prm_subcta: params.prm_subcta ?? '',
        prm_plan_codi: params.prm_plan_codi,
        prm_tari: params.prm_tari ?? '',
        prm_edad: params.prm_edad ?? '',
        prm_fecha: params.prm_fecha ?? '',
        vigen_desde: params.vigen_desde ?? '',
        prm_paren: params.prm_paren ?? '',
        prm_sexo: params.prm_sexo ?? '',
        prm_inte_tipo: params.prm_inte_tipo ?? '',
        cant_inte: params.cant_inte ?? ''
      })
    };

    return this.httpClient.post<ConsultarTarifasIndividualesValoresResponse>(this.apiUrlValores, request).pipe(
      catchError(error => {
        console.error('Error en consultarTarifasIndividualesValores:', error);
        return throwError(() => new Error(error?.message || 'Error al consultar valores de tarifas individuales'));
      })
    );
  }

  // Compatibilidad temporal con consumidores actuales.
  consultarTarifasIndividuales(params: ConsultarTarifasIndividualesParams): Observable<ConsultarTarifasIndividualesResponse> {
    return this.consultarTarifasIndividualesLegacy(params);
  }
}
